





























































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { HttpClient } from "@/utils/HttpClient";
import debounce from "debounce";

@Component
export default class AppSelect extends Vue {
  @Prop() label: string;
  @Prop() name: string;
  @Prop() placeholder: string;
  @Prop({ default: "text" }) type: string;
  @Prop() disabled: boolean;
  @Prop({ default: false }) multiple: boolean;
  @Prop() value: string;
  @Prop() apiUrl: string;
  @Prop() params: any;
  @Prop({ default: "id" }) itemId: string;
  @Prop({ default: "name" }) itemLabel: string;
  @Prop() selectOptions: any;
  @Prop() formSelected: any;
  selected: any[] = [];
  items: any[] = [];
  search: string = "";
  labelClass: string = "block text-gray-600 text-xs font-bold px-3";

  @Emit("input")
  update(e: any) {
    return this.selected;
  }

  @Emit("onEditable")
  onEditable() {}

  @Watch("value")
  async watchValue(val: any[], oldVal: any[]) {
    this.selected = val;
  }

  fetchOptions(search: any, loading: any) {
    if (this.apiUrl) {
      let searchParams: any = {
        ...this.params
      };
      HttpClient.get(this.apiUrl, {
        params: searchParams
      }).then(result => {
        this.items = result.data.data;
      });
    } else {
      this.items = (this.selectOptions || []).filter(
        (m: any) => m[this.itemLabel].indexOf(search) > -1
      );
    }
  }

  @Watch("selectOptions", { immediate: true, deep: true })
  async watchOptions(val: any[], oldVal: any[]) {
    this.items = val;
  }

  onSearch(text: string) {
    if (text !== this.search) {
      this.search = text;
      this.fetchOptions(text, false);
    }
  }

  mounted() {
    this.fetchOptions(null, false);
  }
}
